(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Nibara"] = factory();
	else
		root["Nibara"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	'use strict';
	
	Logger.debug('script api-header loaded');
	
	/** get main vars */
	var app = Voonto.getInstance();
	var vocUserPath = app.lookup('vocento.config.nibara').vocUserPath;
	if (vocUserPath === undefined) {
	    throw 'vocUserPath path in config is empty';
	}
	var libPath = app.lookup('vocento.config.nibara').libPath;
	if (libPath === undefined) {
	    throw 'nibara libPath config is empty';
	}
	
	var sharrreScript = app.load(libPath + 'sharrre/sharrre.min.js');
	
	/** VocUser */
	var vocUserVersion = app.lookup('vocento.config.nibara').vocUserVersion || '201701010101';
	Logger.info('Loading vocuser version: ' + vocUserVersion);
	app.load(vocUserPath + '/vocento-vocuser-preloader.js?v=' + vocUserVersion);
	
	/** Vam */
	var vamPath = app.lookup('vocento.config.nibara').vamPath;
	if (vamPath === undefined) {
	    throw 'nibara vamPath config is empty';
	}
	var vamUrl = vamPath + '/vam.js';
	Logger.info('Loading vam version: ' + vamUrl);
	app.load(vamUrl);
	
	/** querystring vars */
	function getUrlVars() {
	    var vars = [],
	        hash = void 0;
	    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
	    for (var i = 0; i < hashes.length; i++) {
	        hash = hashes[i].split('=');
	        vars.push(hash[0]);
	        vars[hash[0]] = hash[1];
	    }
	    return vars;
	}
	
	window.anchoVentana = $(window).width();
	window.altoVentana = $(window).height();
	
	/** btn up */
	Voonto.$('.suave').click(function () {
	    var id = Voonto.$(this).attr('id');
	    target = Voonto.$('[name=' + id + ']');
	    if (target.length) {
	        Voonto.$('html,body').animate({
	            scrollTop: target.offset().top
	        }, 2000);
	        return false;
	    }
	});
	
	function resizeGeneral() {
	    window.anchoVentana = $(window).width();
	    window.altoVentana = $(window).height();
	
	    // Tamaños de Imágenes
	    Voonto.$(".resize-img").each(function () {
	        var anchopadre = Voonto.$(this).parent().width();
	        Voonto.$(this).aeImageResize({ width: anchopadre });
	    });
	
	    // Elementos cuadrados adaptables
	    Voonto.$(".cuadrar").each(function () {
	        var anchoMismo = Voonto.$(this).width();
	        Voonto.$(this).height(anchoMismo);
	    });
	    // Menus de navegacion en moviles y tabletas
	    if (window.anchoVentana <= 960) {
	        Voonto.$("nav.navegacion .secciones").height(altoVentana);
	        Voonto.$("nav.secciones-abc ul").height(altoVentana);
	        Voonto.$("body").append("<div style='width:100%;position:fixed;top:0;left:0;z-index:2;display:none' id='closer'></div>");
	        Voonto.$("#closer").height(altoVentana);
	        Voonto.$(".boton-navegacion").click(function (e) {
	            Voonto.$("#closer").show();
	            e.stopPropagation();
	            Voonto.$("nav.navegacion .secciones").stop().animate({ left: "0px" }, 500, "linear");
	        });
	        Voonto.$("nav.navegacion .secciones").click(function (e) {
	            e.stopPropagation();
	        });
	        Voonto.$("nav.secciones-abc span").click(function (e) {
	            Voonto.$("#closer").show();
	            e.stopPropagation();
	            Voonto.$("nav.secciones-abc ul").stop().animate({ left: "0px" }, 500, "linear");
	        });
	        Voonto.$("nav.secciones-abc ul").click(function (e) {
	            e.stopPropagation();
	        });
	        Voonto.$("#closer").on("click startouch", function () {
	            Voonto.$(this).hide();
	            Voonto.$("nav.navegacion .secciones").stop().animate({ left: "-210px" }, 500, "linear");
	            Voonto.$("nav.secciones-abc ul").stop().animate({ left: "-210px" }, 500, "linear");
	        });
	    }
	}
	
	// Compartir
	sharrreScript.then(function () {
	    Voonto.$('#facebook').sharrre({
	        share: {
	            facebook: true
	        },
	        template: '<a href="javascript:void(0)" class="boton-cuadrado fb"><span class="fa fa-facebook"></span></a>',
	        enableHover: false,
	        enableTracking: true,
	        click: function click(api, options) {
	            api.simulateClick();
	            api.openPopup('facebook');
	        }
	    });
	
	    Voonto.$('#twitter').sharrre({
	        share: {
	            facebook: true
	        },
	        template: '<a href="javascript:void(0)" class="boton-cuadrado tw"><span class="fa fa-twitter"></span></a>',
	        enableHover: false,
	        enableTracking: true,
	        click: function click(api, options) {
	            api.simulateClick();
	            api.openPopup('twitter');
	        }
	    });
	
	    Voonto.$('#google_plus').sharrre({
	        share: {
	            googlePlus: true
	        },
	        template: '<a href="javascript:void(0)" class="boton-cuadrado gplus"><span class="fa fa-google-plus"></span></a>',
	        enableHover: false,
	        enableTracking: true,
	        click: function click(api, options) {
	            api.simulateClick();
	            api.openPopup('googlePlus');
	        },
	        urlCurl: ''
	    });
	});
	
	Voonto.$(document).ready(function () {
	    resizeGeneral();
	
	    // Control de la navegación
	    var navID = Voonto.$("body").attr('id');
	    Voonto.$('nav ul li a').removeClass("activo");
	    Voonto.$("nav ul li a#" + navID).addClass("activo");
	});
	
	Voonto.$(window).resize(resizeGeneral);
	
	/** fake functions to legacy rendered news */
	window.lzld = function () {
	    return false;
	};
	
	window.ads = {
	    printAds: function printAds(params) {
	        Logger.debug('ads blocked');
	        return false;
	    }
	
	    /** image lazyload */
	};Voonto.lazyLoad = new LazyLoad({
	    elements_selector: ".lzld",
	    data_src: "src"
	});
	
	Voonto.$('.lzld-scroll').on('click', function (ev) {
	    Voonto.lazyLoad.handleScroll();
	});
	
	/** akamai debug */
	if (getUrlVars()['akamai_debug'] === '1') {
	    Voonto.$('body').prepend('<div style="border: solid 1px red;padding: 21px;">x-akamai-device-characteristics: ' + vocento.tracking.root.akamai_device + '</div>');
	}

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// elecciones-andalucia-2018-script.js